export default __webpack_public_path__ + "static/media/nft.a2773412.png";